import { render, staticRenderFns } from "./posAgentSetting.vue?vue&type=template&id=2169c136&scoped=true"
import script from "./posAgentSetting.vue?vue&type=script&lang=js"
export * from "./posAgentSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2169c136",
  null
  
)

export default component.exports